import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { from, Observable } from 'rxjs';
import { LabelService } from '../../shared/services/label.service';
import { EventBus } from '../../shared/utils/eventbus';
import { AsyncPipe } from '@angular/common';
import { MessageFormatPipe } from '../../shared/pipes/messageformat.pipe';

@Component({
  selector: 'app-show-results',
  templateUrl: 'showresults.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MessageFormatPipe],
})
export class ShowResultsComponent {
  @Input() items: Observable<object[]> = from([]);

  resultatenButtonLabel: string;
  resultatenButtonReplacementString = '{{totalItems}}';

  constructor(
    private labelService: LabelService,
    private eventBus: EventBus,
  ) {
    this.resultatenButtonLabel = this.labelService.getLabel(
      'resultatenButtonLabel',
    );
  }

  get items$(): Observable<object[]> {
    return this.items;
  }

  public eventEmit() {
    this.eventBus.emit('filterApp.showResults');
  }
}
